<template>
  <div class="home">
    <HeaderComponent screenName=""/>
    <!-- Business Banner -->
    <BannerComponent
      imageSrc="capabilities/cyber security/cybersecurity-banner.jpg"
      :bannerHeadingColor="'#fff'"
      :isOverlay="true"
      heading="Cybersecurity"
      subheading="Guardians of the Digital Realm by Empowering Trust in a Connected World"
    />

    <div class="modernization-description" data-aos="fade-up">
      <v-row>
        <v-col
          :xs="12"
        >
          <p> {{ appModernizationDesc }} </p>
        </v-col>
      </v-row>
    </div>
    <CardComponent 
      :subHeading="`BENEFITS`"
      :cardItems="benefitsItems"
    />
    <CardComponent 
      :subHeading="`CORE CAPABILITIES`"
      :cardItems="coreCapabilitiesItems"
    />
    <SectionComponent
       relatedTitle="RELATED CAPABILITIES"
       paragraphContent="Supporting over 30 U.S. Federal Agencies, State and Local Government, and Businesses, G14C is a recognized and trusted cybersecurity partner that delivers cybersecurity strategy, threat intelligence, zero-trust architecture, and end-to-end protection for our customer’s IT assets, and data."
      :sections="sectionContents"
      :cards="cardData"
      :additional-content="additionalContent"
    />
    <FooterComponent />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, Ref } from 'vue';

// Components
import HeaderComponent from '@/components/HeaderComponent.vue';
import BannerComponent from '@/components/BannerComponent.vue';
import CardComponent from '@/components/CardComponent.vue';
import SectionComponent from '@/components/SectionComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';

export default defineComponent({
  components: {
    HeaderComponent,
    BannerComponent,
    CardComponent,
    SectionComponent,
    FooterComponent
  },
  data() {
    return {
      appModernizationDesc: 'G14C cybersecurity subject matter experts provide Information System Security Officer as a Service (ISSOaaS) and capabilities for designing and developing cybersecurity solutions, and processes to protect our customers’ infrastructure, networks, systems, applications, and data. Our cyber experts develop and implement cyber solutions that identify, minimize, isolate and mitigate cyber threats. Our cyber experts design, test, and implement response and disaster recovery plans based on our customer’s cyber risk policies and standards. Our cyber professionals have expertise implementing and utilizing Security Information and Event Management (SIEM) tools and technologies performing tasks that involve Continuous Diagnostics and Mitigation (CDM), incident response, threat hunting, disaster recovery, and business continuity.',
      benefitsItems: [
        {
          id: 0,
          subFolder:'capabilities',  
          folder:'cyber security',
          imageUrl: 'Threat Intelligence.jpg',
          text: 'Active Threat Intelligence',
          hoverIcon: 'vector.png',
          hoverText: 'Continuously gathering and analyzing information about potential cybersecurity threats and taking action to prevent or mitigate them before they occur.'
        },{
          id: 1,
          subFolder:'capabilities',  
          folder:'cyber security',
          imageUrl: 'CloudSecurity.jpg',
          text: 'Cloud Security',
          hoverIcon: 'chart.png',
          hoverText: ' Identifying and collecting data from various virtual machines, cloud storage, and software-as-a-service (SaaS) applications performing log analysis, file carving, data recovery, and metadata analysis, to identify events and  potential threats or malicious activity.'
        },{
          id: 2,
          subFolder:'capabilities', 
          folder:'cyber security',
          imageUrl: 'Security Strategy.jpg',
          text: 'Effective Security Strategy',
          hoverIcon: 'trend-down.png',
          hoverText: 'Preparing a comprehensive plan that outlines the approach to identifying, assessing, and managing risks to information assets based on an organization’s policies, procedures, technologies, and training requirements. '
        },{
          id: 3,
          subFolder:'capabilities', 
          folder:'cyber security',
          imageUrl: 'Security Solutions.jpg',
          text: 'Managed Security Solutions',
          hoverIcon: 'lock.png',
          hoverText: 'Helping organizations manage their information security risks, by performing the day-to-day monitoring, management, and maintenance of the security infrastructure.'
        }
      ],
      
      coreCapabilitiesItems: [
        {
          id: 4,
          subFolder:'capabilities',  
          folder:'cyber security',
          imageUrl: 'Cyber Defense.jpg',
          text: 'Active Cyber Defense',
          hoverIcon: 'analysis.png',
          hoverText: 'Taking proactive measures take to defend against cyber threats. Involves actively monitoring and analyzing network traffic and system behavior, identifying potential threats and vulnerabilities, and taking immediate action to prevent or mitigate attacks.'
        },{
          id: 5,
          subFolder:'capabilities',  
          folder:'cyber security',
          imageUrl: 'Breach Detection.jpg',
          text: 'Breach Detection',
          hoverIcon: 'inventory.png',
          hoverText: 'Identifying and responding to security breaches or cyberattacks. Involves monitoring network traffic and system behavior, analyzing log data and security alerts, and identifying anomalous activity, utilizing detection technologies and techniques such as IDS/IPS, SIEM, XDR, NTA, SOAR and UEBA.'
        },{
          id: 6,
          subFolder:'capabilities',  
          folder:'cyber security',
          imageUrl: 'Governance- Risk- Compliance.jpg',
          text: 'Governance, Risk, and Compliance',
          hoverIcon: 'ai-brain.png',
          hoverText: 'Establishing the management framework, and involves identifying and addressing risks, ensuring compliance with relevant regulations and industry standards, while establishing effective governance practices.'
        },{
          id: 7,
          subFolder:'capabilities',  
          folder:'cyber security',
          imageUrl: 'Incident Response.jpg',
          text: 'Incident Response',
          hoverIcon: 'cloud-done.png',
          hoverText: 'Preparing for, identifying, containing, and resolving security incidents that threaten systems, networks, or data. Involves a coordinated and structured approach to handling security incidents and minimizes the impact of the incident.'
        },{
          id: 8,
          subFolder:'capabilities',  
          folder:'cyber security',
          imageUrl: 'Threat Hunting.jpg',
          text: 'Threat Hunting ',
          hoverIcon: 'software-license.png',
          hoverText: 'Using advanced security analytics tools and techniques, such as AI/ML, to analyze large volumes of data, log files, network traffic to identify anomalous activity. Analyzing system activity to identify patterns and anomalies that indicate the presence of a threat.'
        },{
          id: 9,
          subFolder:'capabilities',  
          folder:'cyber security',
          imageUrl: 'Vulnerability.jpg',
          text: 'Vulnerability Management',
          hoverIcon: 'microservices.png',
          hoverText: 'Discovering, assessing, remediating potential vulnerabilities to resolve them before they become bigger problems, and then verifying the remediation steps are successful. '
        }
      ],
      sectionContents: [
        '“Your team was instrumental in establishing the CMS ISPG’s Security Data Lake (SDL) platform and integrating it with the Continuous Diagnostic and Monitoring (CDM) data sourced from AWS for establishing a consolidated view of the security poster of all FISMA systems. G14C utilized the Agile Development Framework and established a CI/CD pipeline to successfully design, develop and build the SDL. The contractor successfully applied Human Centered Design (HCD) while developing various SDL dashboards increasing the usability and accessibility and overall adoption.”',
        '“This contractor has successfully performed numerous complex security related engineering tasks extremely well over the life of the system, and successfully met the SEC CISO mandate to encrypt all SEC data in transit and at rest, for mission critical systems. The team successfully implemented file level encryption end to end from submission, processing, storage, and dissemination, protecting SEC’s High Value Assets (HVA)”',
      ],
      additionalContent: [
        'CMS, CO', 
        'SEC, Assistant Director', 
      ],
      cardData: [
        {
          className: 'devsecops',
          color: '#7594FE',
          heading: 'Application Modernization	',
          link: 'application-modernization'
        },
        {
          className: 'cloud',
          color: '#50E1FE',
          heading: 'Cloud',
          link: 'cloud'
        },
        {
          className: 'security',
          color: '#E2BF66',
          heading: 'Security Data Lake',
          link: 'security-data-lake'
        },
      ]
    };
  },
  setup() {
    return {
    };
  },
});
</script>
<style scoped>
.modernization-description{
  padding: 32px;
  padding-left: 100px;
  padding-right: 100px;
}
.modernization-description div div p{
  font-size: 24px;
}
@media (max-width: 1000px) {
  .modernization-description{
    padding: 27px;
    padding-left: 80px;
    padding-right: 80px;
  }
  .modernization-description div div p{
    font-size: 24px;
  }
}
@media (max-width: 850px) {
  .modernization-description{
    padding: 22px;
    padding-left: 65px;
    padding-right: 65px;
  }
  .modernization-description div div p{
    font-size: 22px;
  }
}
@media (max-width: 750px) {
  .modernization-description{
    padding: 17px;
    padding-left: 50px;
    padding-right: 50px;
  }
  .modernization-description div div p{
    font-size: 20px;
  }
}
@media (max-width: 600px) {
  .modernization-description{
    padding: 12px;
    padding-left: 35px;
    padding-right: 35px;
  }
  .modernization-description div div p{
    font-size: 18px;
  }
}
</style>